/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CreateContactSettingRequestContactSettingFromJSON, CreateContactSettingRequestContactSettingToJSON } from './CreateContactSettingRequestContactSetting';
import { UpdateCompanySettingRequestCompanySettingFieldsInnerFromJSON, UpdateCompanySettingRequestCompanySettingFieldsInnerToJSON } from './UpdateCompanySettingRequestCompanySettingFieldsInner';
export function UpdateCompanySettingRequestFromJSON(json) {
    return UpdateCompanySettingRequestFromJSONTyped(json, false);
}
export function UpdateCompanySettingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companySetting: !exists(json, 'company_setting')
            ? undefined
            : CreateContactSettingRequestContactSettingFromJSON(json['company_setting']),
        companySettingFields: !exists(json, 'company_setting_fields')
            ? undefined
            : json['company_setting_fields'].map(UpdateCompanySettingRequestCompanySettingFieldsInnerFromJSON)
    };
}
export function UpdateCompanySettingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_setting: CreateContactSettingRequestContactSettingToJSON(value.companySetting),
        company_setting_fields: value.companySettingFields === undefined
            ? undefined
            : value.companySettingFields.map(UpdateCompanySettingRequestCompanySettingFieldsInnerToJSON)
    };
}
